<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div class='container'>
      <h1 style='text-align: center;margin-top: 10px'>{{ details.F_Title }}竞采详情</h1>
      <div class='Time'>
        <span class='goBack' @click='goBack()'><i class='el-icon-back'></i>返回</span>
        <span class='lateTime' v-if='details.F_UpdateTime'>最后更新时间：{{ details.F_UpdateTime | dateNoT }}</span>
        <span class='lateTime' v-else>创建时间：{{ details.F_CreateTime | dateNoT }}</span>
      </div>
      <div class='option-box'>
        <p class='option-sty'>内容摘要：</p>
      </div>
      <div class="hg-news-content">
        <div v-html="details.F_Content"></div>
      </div>
      <div class='centerDocx' v-if='details.F_AttachUrl'>
        <img src='/static/images/HomeTH/WORD.png' style='border: none;width: 64px;height: 64px;margin: 20px 0'
             @click='Download(details.F_AttachUrl)' alt='' />
        <a @click='Download(details.F_AttachUrl)'>{{ details.F_AttachName }}</a>
        <!--        <span class='download' @click='Download(details.F_AttachUrl)'>下载</span>-->
      </div>
    </div>
  </div>
</template>

<script lang="js">
  export default {
    // props: {
    //     Id: String,
    //     default: ''
    // },
    data() {
      return {
        fullscreenLoading: false,
        Id: '',
        url: {
          GetNews: SZH.assets.api + '/Market/GetNews2'
        },
        details: {
          F_Title: '',
          F_UpdateTime: '',
          F_AttachName: '',
          F_AttachUrl: '',
          F_Content: ''
        }
      }
    },
    methods: {
      loadData() {
        let self = this
        self.fullscreenLoading = true
        self.$http.post(self.url.GetNews, {
          keyValue: self.Id
        }).then(result => {
          if (result.state == 1 && result.data) {
            self.fullscreenLoading = false
            // self.$message.success('获取成功')
            self.details = result.data
          } else {
            self.fullscreenLoading = false
            self.$message.error(result.message)
            self.details = []
          }
        })
      },
      Download(url) {
        window.open(SZH.assets.image + '/' + url)
      },
      goBack() {
        let self = this
        self.$router.go(-1)
        // history.go(-1)//返回浏览器历史的上一页
      }
    },
    computed: {},
    components: {},
    mounted() {
      this.Id = this.$route.query.Id
      this.loadData()
    }
  }

</script>
<style lang="css" scoped></style>
<style scoped>
  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .lateTime {
    display: block;
    width: 100%;
    text-align: right;
    color: #a89c9c;
  }

  .centerDocx {
    display: flex;
    margin: 50px 0;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .download {
    margin-top: 20px;
    width: 70px;
    height: 36px;
    text-align: center;
    line-height: 34px;
    border: 1px solid #000000;
    border-radius: 5px;
    font-weight: bold;
  }

  .centerDocx:hover {
    /*background-color: #1cb9e9;*/
    /*color: white;*/
    cursor: pointer;
  }

  .option-box {
    background: #f5f5f5;
    padding: 20px;
    margin-top: 20px;
  }

  .option-sty {
    font-size: 18px;
  }

  .hg-news-content {
    padding: 0 70px;
    margin: 30px 0;
  }

  .goBack {
    width: 60px;
    cursor: pointer;
    font-size: 16px;
  }

  .Time {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
</style>



// WEBPACK FOOTER //
// src/views/BidBuyNews/BidBuyNewsDetail.vue